import React, { useEffect } from "react";
import { useSocket } from "../../context/SocketContext";
import { useDispatch, useSelector } from "react-redux";
import Search from "./Search";
import UsersRow from "./UsersRow";

const Users = () => {
  const { filteredOnlineUsers, guestUsers } = useSelector((state) => state.chat);

  
  return (
    <div className="users-box border position-relative">
      <Search />
      {filteredOnlineUsers.length > 0 ? (
          filteredOnlineUsers.map((user, index) => (
            <UsersRow key={index} user={user} />
          ))
        ) : (
          <div className="no-users-found">
            <p>No users found</p>
          </div>
        )}
      {guestUsers > 0 && (
        <p className="online-users-text p-3 mb-o position-sticky bottom-0 bg-white w-100">
          And {guestUsers} guest user{guestUsers > 1 ? "s are" : " is"} online
        </p>
      )}
    </div>
  );
};

export default Users;
